import { useContext, useEffect, useState } from "react";
import EstetoscopioIcon from "./assets/EstetoscopioIcon";
import OjoIcon from "./assets/OjoIcon";
import {
  EtiquetaAzulBusquedaBody,
  EtiquetaAzulBusquedaContainer,
} from "./localStyle";
import ModalSeleccionBusqueda from "../ModalSeleccionBusqueda/ModalSeleccionBusqueda";
import { hideModal, showModal } from "global/context/action/modal/modal";
import { GlobalContext } from "global/context/Provider";
import { PortalContext } from "_+_Portal/context/Provider";

const EtiquetaAzulBusqueda = ({ dtoPrestacion, fullStr }) => {
  const { modalDispatch } = useContext(GlobalContext);
  const { nuevoTurnoState } = useContext(PortalContext);
  const [data, setData] = useState([]);
  const dtobusqueda = dtoPrestacion
    ? dtoPrestacion
    : nuevoTurnoState.nuevoTurno.dtoBusqueda;
  const isAgenda =
    dtobusqueda?.GruposMedico === undefined && dtobusqueda?.grupoMedico?.Id < 0;

  const dismiss = () => {
    hideModal()(modalDispatch);
  };

  const onClickVerEstudiosAgregados = () => {
    if (data?.length > 1) {
      showModal(
        <ModalSeleccionBusqueda data={data} dismiss={dismiss} />,
        "Tus turnos agregados",
        dismiss,
        false,
        {},
        "centro",
        true,
      )(modalDispatch);
    }
  };

  useEffect(() => {
    if (isAgenda) {
      setData((prevData) => [...prevData, dtobusqueda?.grupoMedico]);
    } else {
      setData(dtobusqueda?.GruposMedico);
    }
  }, [isAgenda, dtobusqueda?.grupoMedico]);

  return (
    <EtiquetaAzulBusquedaContainer>
      <EtiquetaAzulBusquedaBody
        fullStr={fullStr}
        onClick={onClickVerEstudiosAgregados}
      >
        <EstetoscopioIcon />
        {data?.length > 1 ? (
          <>
            <span>VER ESTUDIOS AGREGADOS</span>
            <OjoIcon />
          </>
        ) 
        // : rutaState.ruta.data.seleccionRuta === "laboratorio" ? (
        //   <span>
        //     {nuevoTurnoState.nuevoTurno.dtoBusqueda?.particular &&
        //       "PARTICULAR: "}
        //     {nuevoTurnoState.nuevoTurno.dtoBusqueda.laboSeleccion}
        //   </span>
        // ) 
        : (
          data?.map((item, index) => (
            <span key={index}>
              {(item.Particular || item.particular) && "PARTICULAR: "}
              {item.Descripcion ? item.Descripcion : item.descripcion}
            </span>
          ))
        )}
      </EtiquetaAzulBusquedaBody>
    </EtiquetaAzulBusquedaContainer>
  );
};

export default EtiquetaAzulBusqueda;
